import React from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'next-i18next';
import useRouter from 'src/shared/hooks/useRouter';

const BackButton = (props) => {
    const { t } = useTranslation();
    const router = useRouter();

    const back = () => {
        if (props.link) {
            router.replacePath(props.link);
        } else {
            router.back();
        }
    };

    return (
        <div className={`${styles.container} ${props.className}`}>
            <div className={styles.back} onClick={back} role="presentation">
                <i className={`icon-back ${styles.arrow}`} />
                <p className={styles.portalTitle}>{t('back')}</p>
            </div>
        </div>
    );
};

BackButton.defaultProps = {
    className: '',
};

export default BackButton;
